module.exports = __webpack_public_path__ + "img/no-banner.720fd279.jpg";